import { render, staticRenderFns } from "./text-button.vue?vue&type=template&id=7ecc99b8&scoped=true&"
import script from "./text-button.vue?vue&type=script&lang=js&"
export * from "./text-button.vue?vue&type=script&lang=js&"
import style0 from "./text-button.vue?vue&type=style&index=0&id=7ecc99b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecc99b8",
  null
  
)

export default component.exports